<template>
  <v-btn
    outlined small color="primary" class="action-btn elevation-0 rounded-lg"
    height="32"
    :loading="loading"
    @click="click"
  >
    <v-icon class="uikit-icon plus primary size-20" :class="icon" />
    <span class="ml-1 btn-text">{{ title }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonOutlineSmall',

  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>
